///  M.U.S.T.   ///

import React, { useState } from "react";
import {
  Badge,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";
import { getNavItemsForRole } from "../config/roleConfig";

const EXPANDED_WIDTH = 155;
const COLLAPSED_WIDTH = 56;

const Sidebar = ({ user, messages }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const toggleCollapsed = () => {
    setIsCollapsed((prev) => {
      localStorage.setItem("sidebarCollapsed", String(!prev));
      return !prev;
    });
  };

  const navItems = getNavItemsForRole(user.userType);

  return (
    <Drawer
      sx={{
        width: isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
        flexShrink: 0,
        transition: "width 0.25s ease",
        "& .MuiDrawer-paper": {
          width: isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
          boxSizing: "border-box",
          overflowX: "hidden",
          transition: "width 0.25s ease",
          display: "flex",
          flexDirection: "column",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <List sx={{ paddingTop: 7, flexGrow: 1 }}>
        {navItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <Tooltip
              title={isCollapsed ? item.label : ""}
              placement="right"
              key={item.path}
            >
              <ListItem
                button
                component={Link}
                to={item.path}
                sx={{ justifyContent: isCollapsed ? "center" : "flex-start" }}
              >
                <ListItemIcon
                  sx={{ minWidth: isCollapsed ? "auto" : 40, justifyContent: "center" }}
                >
                  {item.badge ? (
                    <Badge badgeContent={messages.length} color="primary">
                      <IconComponent />
                    </Badge>
                  ) : (
                    <IconComponent />
                  )}
                </ListItemIcon>
                {!isCollapsed && <ListItemText primary={item.label} />}
              </ListItem>
            </Tooltip>
          );
        })}
      </List>

      <Divider />
      <Box
        sx={{
          display: "flex",
          justifyContent: isCollapsed ? "center" : "flex-end",
          p: 0.5,
        }}
      >
        <Tooltip title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"} placement="right">
          <IconButton onClick={toggleCollapsed} size="small">
            {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
